import { IItemsResponseV2 } from 'src/api/types';
import { IMenuItem } from 'src/types/menu.types';

// this function is used when fetching a menu, therefore, several properties have no value
export const formatItems = (menuItems: IItemsResponseV2[]): IMenuItem[] =>
  menuItems.map((menuItem: IItemsResponseV2) => ({
    itemId: menuItem.item_id,
    name: menuItem.name,
    description: menuItem.description,
    type: menuItem.type,
    image: menuItem.asset_url,
    ranges: menuItem.ranges,
    prices: {
      taxRate: undefined,
      priceBands: [],
    },
    tax_rate: null,
    new_prices: [],
    plu: menuItem.plu,
    consumerName: undefined,
    posId: undefined,
    displayOrder: undefined,
    recipeId: undefined,
    parentItemId: null, // v2 only returns global items, i.e. with fk_parent_item_id = null
    optionGroup: [],
    deposit_return_scheme: null,
  }));
